const LeftBarScreen = {
   TopicFilter: 0,
   DeckFilter: 1,
   CreateCard: 2,
   Home: 3,
   Logo: 4,
   Hidden: 5,
   EvidenceReview: 6,
   CreateConjecture: 7,
   ConjectureReview: 8,
   PortfolioManager: 9,
   UserDetails: 10,
   Messages: 11,
   IncubatorManager: 12,
   ConnectionCreateConjecture: 13,

};

exports.LeftBarScreen = LeftBarScreen;

const DisplayPage = {
   Intro: 0,
   Home: 1,
   ListView: 2,
   EvidenceReview: 3,
   Faq: 4,
   Evidence: 5,
   UserProfile: 6,
   PrivateMessages: 7,
   ReviewRejected: 8,
   ConjectureReview: 10,
   Conjecture: 11,
   EmailWhitelist: 12,
   AdminStats: 13,
   Portfolio: 14,
   PortfolioList: 15,
   EditProfile: 16,
   Generic: 17,
   CreateSponsorPortfolio: 18,
   IncubatorPublic: 19,
   IncubatorList: 20,
   IncubatorEdit: 21,
   Awards: 22,
   EvidenceCreation: 23,
   ConnectionsView: 24,
   ConjectureCreation: 25,

};

exports.DisplayPage = DisplayPage;

exports.UserRole = {
   Admin: 1,
   Sponsor: 2,
};